<svg
  id="f001897d-af5b-408c-8317-c3300641b4fc"
  data-name="Lager 1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 196.3 56.8"
>
  <defs>
    <style>
      .a556ddb8-bff8-4cfa-a9f1-1f3198cfd319 {
        fill: #1a1a1a;
      }
      .a72f93e3-96b9-471b-a6f9-c9b1ce14c20e {
        fill: url(#f33d30f8-1a2e-42f0-bce5-fd931a3cacb4);
      }
    </style>
    <linearGradient
      id="f33d30f8-1a2e-42f0-bce5-fd931a3cacb4"
      x1="4.89"
      y1="28.05"
      x2="187.77"
      y2="28.05"
      gradientTransform="matrix(1, 0, 0, -1, 0, 58)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#010101" />
      <stop offset="0.03" stop-color="#232423" />
      <stop offset="0.09" stop-color="#565756" />
      <stop offset="0.14" stop-color="#848484" />
      <stop offset="0.2" stop-color="#aaa" />
      <stop offset="0.26" stop-color="#c9c9c9" />
      <stop offset="0.32" stop-color="#e1e1e1" />
      <stop offset="0.39" stop-color="#f2f2f2" />
      <stop offset="0.46" stop-color="#fcfcfc" />
      <stop offset="0.55" stop-color="#fff" />
      <stop offset="0.61" stop-color="#fcfcfc" />
      <stop offset="0.67" stop-color="#f1f1f1" />
      <stop offset="0.73" stop-color="#dfdfdf" />
      <stop offset="0.78" stop-color="#c5c5c5" />
      <stop offset="0.83" stop-color="#a5a5a5" />
      <stop offset="0.88" stop-color="#7c7c7c" />
      <stop offset="0.93" stop-color="#4d4d4d" />
      <stop offset="0.98" stop-color="#171717" />
      <stop offset="1" stop-color="#010101" />
    </linearGradient>
  </defs>
  <path
    class="a556ddb8-bff8-4cfa-a9f1-1f3198cfd319"
    d="M188,56.8H8.3A8.37,8.37,0,0,1,0,48.4V8.3A8.28,8.28,0,0,1,8.3,0H188a8.28,8.28,0,0,1,8.3,8.3V48.4A8.43,8.43,0,0,1,188,56.8Z"
  />
  <path
    class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e"
    d="M26.6,35.8c-2.9,0-4.4-.9-4.4-3.1V27.2c0-2.1,1.5-3.1,4.4-3.1h9.5v1.7H25.9c-.9,0-1.2.3-1.2,1.2v5.9c0,.8.3,1.2,1.2,1.2H36.1v1.7Z"
  />
  <path
    class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e"
    d="M54.2,35.8l-1.3-2.1H43.4l-1.3,2.1H39.5l7.2-11.7h2.8l7.2,11.7Zm-6.1-9.7L44.5,32h7.3Z"
  />
  <path
    class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e"
    d="M73.7,35.8,71.2,32H62.6v3.8H60.1V24.1H72.2c1.7,0,3.9.4,3.9,2.8V29a2.85,2.85,0,0,1-2.3,2.7l2.8,4.1Zm-.4-9c0-.8-.4-1-1.2-1H62.6v4.3h9.5c.8,0,1.2-.3,1.2-1Z"
  />
  <path
    class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e"
    d="M93.9,35.8H80.3V24.1H93.8c2.2,0,3.2,1.1,3.2,2.6v6.5C97,34.8,96.1,35.8,93.9,35.8Zm.7-9.1a.92.92,0,0,0-1-.9H82.8v8.3H93.3c.9,0,1.3-.3,1.3-.9Z"
  />
  <path
    class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e"
    d="M123.4,35.8V27c0-.9-.4-1.2-1.5-1.2h-9.5v9.9h-2.5V24.1h12.4c2.9,0,3.7,1.1,3.7,3.1v8.5h-2.6Z"
  />
  <path
    class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e"
    d="M146.3,35a4.89,4.89,0,0,1-3,.8H134a4.56,4.56,0,0,1-2.9-.8,3.27,3.27,0,0,1-.9-2.6V27.6a3.65,3.65,0,0,1,.8-2.7,4.89,4.89,0,0,1,3-.8h9.3a4,4,0,0,1,2.9.8,3.37,3.37,0,0,1,.9,2.7v4.8A2.87,2.87,0,0,1,146.3,35Zm-1.6-8.5c0-.5-.4-.7-1.1-.7h-9.7c-.8,0-1.1.2-1.1.7v6.8c0,.5.4.7,1.1.7h9.7c.8,0,1.1-.2,1.1-.7Z"
  />
  <path class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e" d="M151.6,35.8V24.1h2.5V35.7Z" />
  <path
    class="a72f93e3-96b9-471b-a6f9-c9b1ce14c20e"
    d="M172.1,35.8,169.6,32H161v3.8h-2.5V24.1h12.1c1.7,0,3.9.4,3.9,2.8V29a2.85,2.85,0,0,1-2.3,2.7l2.8,4.1Zm-.3-9c0-.8-.4-1-1.2-1h-9.5v4.3h9.5c.8,0,1.2-.3,1.2-1Z"
  />
</svg>
